import { useSelector } from '@legendapp/state/react';
import { useTranslation } from 'react-i18next';
import { ui$, setColorTheme } from '../store';
import { DropdownMenuCheckboxItem } from '../design-system';

const SidebarThemeSwitcher = () => {
  const { t } = useTranslation(['sidebar']);
  const colorTheme = useSelector(() => ui$.colorTheme.get());

  return (
    <DropdownMenuCheckboxItem
      checked={colorTheme === 'dark'}
      onCheckedChange={(checked) => setColorTheme(checked ? 'dark' : 'light')}
      onSelect={(event) => event.preventDefault()}
    >
      <span>{t('sidebar:themes.dark')}</span>
    </DropdownMenuCheckboxItem>
  );
};

export default SidebarThemeSwitcher;
